module.exports = __webpack_public_path__ + "static/media/teamsicon.03b7e5bb.svg";